import React, { useState } from 'react';
import { Row, Col, Tabs, Tab } from 'react-bootstrap';
import { LogisticsDateTabs } from './tabs';
import { getLocalStorage, setLocalStorage } from 'lib/localStorage';

export const LogisticsOverview: React.FC = () => {
  const allowedDepartments = ['sjælland', 'fyn'] as const;
  const storedDepartment = getLocalStorage('logistics-overview-department');
  const initialDepartment = allowedDepartments.includes(storedDepartment as (typeof allowedDepartments)[number]) ? storedDepartment : 'fyn';
  const [department, setDepartment] = useState(initialDepartment);

  const handleSelectTab = (key: string | null) => {
    if (key && allowedDepartments.includes(key as (typeof allowedDepartments)[number])) {
      setLocalStorage('logistics-overview-department', key);
      setDepartment(key);
    }
  };

  return (
    <>
      <Row className="department-tabs-wrapper">
        <Col>
          <Tabs defaultActiveKey={department} id="tabs-department" className="mb-3" onSelect={(k) => handleSelectTab(k)}>
            <Tab eventKey="sjælland" title="Sjælland">
              {department === 'sjælland' && <LogisticsDateTabs department={department} />}
            </Tab>
            <Tab eventKey="fyn" title="Jylland / Fyn">
              {department === 'fyn' && <LogisticsDateTabs department={department} />}
            </Tab>
          </Tabs>
        </Col>
      </Row>
    </>
  );
};
